(ns net.kestec.mhda-pilgrimage.menu
  (:require
    ["@mui/material/Divider" :default Divider]
    ["@mui/material/MenuList" :default MenuList]
    ["@mui/material/MenuItem" :default MenuItem]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [re-frame.core :as rf]
    [net.kestec.mhda-pilgrimage.route :as route]))




(defn menu-items []
  (let [route-path (str (:path @(rf/subscribe [::route/route])))
        admin? @(rf/subscribe [::db/get ::db/me :enriched-session :is_admin])
        has-groups? (not (empty? @(rf/subscribe [::db/get ::db/me :enriched-session :groups])))
        valid? @(rf/subscribe [::db/get ::db/me :enriched-session :valid])
        ]
    ;(println "admin?" route-path)
    [[:> MenuItem {:component "a" :href "/"} "Home"]
     [:> MenuItem {:component "a" :href "/dashboard"} "Mein Anmeldestatus"]

     (when (and valid? has-groups?) [:> Divider])
     (when (and valid? has-groups?) [:> MenuItem {:component "a" :href "/admin/dashboard"} "Anmeldeübersicht"])
     (when (and valid? has-groups?) [:> MenuItem {:component "a" :href "/admin/application-list"} "Anmeldeliste"])

     (when (and valid? admin?) [:> MenuItem {:component "a" :href "/admin/setup"} "Einstellungen"])
     ;(when (and valid? admin?) [:> MenuItem {:component "a" :href "/admin/log-list"} "Log Liste"])
     [:> Divider]
     [:> MenuItem {:component "a" :href "/api/auth/logout-request"} "Logout"]
     ])
  )
